import type { SelectOption } from '@/types'

export const catalogVisibilityOptions: SelectOption[] = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '6', label: '6' },
  { value: '12', label: '12' }
]

export const centerOptions: SelectOption[] = [
  { value: 'aeroville', label: 'Aeroville' },
  { value: 'cifa', label: 'CIFA' },
  { value: 'fashion_center', label: 'Fashion Center' },
  { value: 'lem888', label: 'LEM888' },
  { value: 'silk_road_paris', label: 'Silk Road Paris' }
]

